import { PalmettoTag, PalmettoTooltip } from '@palmetto/dsm-components';

import { ProgramType, ProgramTypeLabels } from 'types';

// DataTable cells are a fixed-height single line, so tags can't wrap.
const MAX_VISIBLE_PROGRAM_TYPES = 1;

// DataTable rows clip overflow; fixed positioning keeps the tooltip visible.
const TOOLTIP_POSITIONING = { strategy: 'fixed', placement: 'top', gutter: 4 } as const;

export interface ProgramTypeTagsProps {
  programTypes: ProgramType[];
}

export const ProgramTypeTags = ({ programTypes }: ProgramTypeTagsProps) => {
  const visible = programTypes.slice(0, MAX_VISIBLE_PROGRAM_TYPES);
  const hidden = programTypes.slice(MAX_VISIBLE_PROGRAM_TYPES);
  const hiddenLabels = hidden.map((pt) => ProgramTypeLabels[pt] ?? pt);

  return (
    <div className="flex flex-row flex-nowrap items-center gap-4 overflow-hidden">
      {visible.map((pt) => (
        <PalmettoTag key={pt} label={ProgramTypeLabels[pt] ?? pt} />
      ))}
      {hidden.length > 0 && (
        <PalmettoTooltip content={hiddenLabels.join(', ')} position="top-center" positioning={TOOLTIP_POSITIONING}>
          <button type="button" aria-label={`${hidden.length} more program types`}>
            <PalmettoTag label={`+${hidden.length}`} />
          </button>
        </PalmettoTooltip>
      )}
    </div>
  );
};
